import { Body1, Button, Card, Title2, tokens } from '@fluentui/react-components';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../config/authConfig';
import { authenticateInTeams, initTeams, openInBrowser } from '../teams/teamsContext';

export function SignInScreen() {
  const { instance } = useMsal();

  async function signIn() {
    // Im Teams-Client wird der MSAL-Redirect im iframe blockiert → Teams-Popup-Flow.
    const { inTeams } = await initTeams();
    if (!inTeams) {
      void instance.loginRedirect(loginRequest);
      return;
    }
    const ok = await authenticateInTeams();
    if (ok) {
      window.location.reload(); // Account liegt nun im (geteilten) localStorage
    } else {
      void openInBrowser('/'); // Fallback: im Browser anmelden
    }
  }

  return (
    <div
      style={{
        height: '100%',
        display: 'grid',
        placeItems: 'center',
        backgroundColor: tokens.colorNeutralBackground2,
      }}
    >
      <Card
        style={{
          padding: tokens.spacingVerticalXXL,
          display: 'flex',
          flexDirection: 'column',
          gap: tokens.spacingVerticalL,
          maxWidth: '380px',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <Title2>M365 Adminbox</Title2>
        <Body1>
          Self-Service-Portal für Entra ID &amp; Microsoft 365. Bitte mit Ihrem Geschäftskonto anmelden.
        </Body1>
        <Button appearance="primary" size="large" onClick={signIn}>
          Anmelden
        </Button>
      </Card>
    </div>
  );
}
